// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q_AP","left":"styles_left__2opkj"};